if (!customElements.get('mobile-filters-toggle')) {
  class MobileFiltersToggle extends HTMLElement {
    connectedCallback() {
      // Show the toggle immediately without waiting for scroll
      this.classList.add('mobile-filters-toggle--active');
    }
  }
  customElements.define('mobile-filters-toggle', MobileFiltersToggle);
}